import React from 'react';
// material-ui
import { Button, ButtonGroup, Grid, Box, IconButton } from '@mui/material';
import Card from './Card';
// function
import _ from 'lodash';
// type
import { FirstMenu, MenuDish, NewMenuPrice } from '../../models';
// constant
import BASE_CHECK_TYPE from '../../constants/regular.constant';
import { SwitchComponent } from './dish-group-detail';
// css
import './scss/first-menu-detail.scss'
import { export2Excel, setEmptyNewPriceForm, setEmptyNewPriceValue, sheetDataType } from '../../constants/utils';
import { apiManage_rbp } from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';

import i18n from '../../i18n';
import CommonInput, { CommonInputType } from '../../component/form/common-input.component';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import LSM from '../../modules/cache/tool-local-storage';
import ButtonComponent from '../../component/button/button.component';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import { FilterNone } from '@mui/icons-material';
import { getCurrencyName } from '../../constants/tool.fn';

export default class FirstMenuDetail extends React.Component<Props, State> {
    // 从缓存中拿服务器地址
    public SERVER_URL = LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL);
    public isDelete: boolean = false;
    public state: State = {
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 一级菜单图片
        avatarUrl: '',
        // 菜品不受轮次限制
        isJoiningGlobalLimit: false,
        // $ 新菜单价格方案
        // 当前选中的星期数
        curSelectWeek: 1,
        // 当前菜单价格表单数组
        curMenuPriceForm: [] as any,
        // 当前选中的菜单价格
        curSelectMenuPriceForm: setEmptyNewPriceForm(this.props.extraMenuData),
        // 当前菜单价格表单
        curPricesForm: [
            {
                key: 'main_group_name',
                label: 'menu_and_dishes_page_group_name',
                regularType: 'required',
                width: 12 as const,
                require: true,
            },
            {
                key: 'normal_price',
                label: 'menu_page_normal_price',
                disabled: true,
                width: 4 as const,
                value: '0.00',
            },
            {
                key: 'child_price',
                label: 'menu_and_dishes_page_child_price',
                disabled: true,
                width: 4 as const,
                value: '0.00',
            },
            {
                key: 'other_price',
                label: 'menu_and_dishes_page_other_price',
                disabled: true,
                width: 4 as const,
                value: '0.00',
            },
        ],
        // 二次确认 - 一键复制
        isShowConfirmDialog: false
    }

    // *********************
    // Life Cycle Function
    // *********************
    constructor(props: Props) {
        super(props);
        this.clearOtherDetailInfo = this.clearOtherDetailInfo.bind(this);
        this.onSaveAction = _.debounce(this.onSaveAction, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }

    async componentDidMount() {
        await this.init();
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */
    async init() {
        const { detail } = this.state;
        const isJoiningGlobalLimit = detail.menu_item_slu?.reduce((acc, cur) => {
            return !!(acc && ((cur.menu_item || []).length > 0 ? cur.not_joining_global_limit : true))
        }, true)
        // 处理新菜单价格方案
        this.handleNewMenuPrice();

        this.setState({
            avatarUrl: detail.main_group_id ?
                `${this.SERVER_URL}/menu/${detail.main_group_id}.jpg?randomId=${Math.random()}`
                :
                '',
            isJoiningGlobalLimit: !!isJoiningGlobalLimit
        })

    }

    /**
     * 修改表单
     * @param value
     * @param key
     * @param other 用来同步更新其他数据
     */
    onChange(value: string, key: string, other?: { key: string, value: string }) {
        const { detail } = this.state;
        _.set(detail, key, value)
        other && _.set(detail, other.key, other.value)
        this.setState({
            detail
        })
    }

    /**
     * 表单回调
     * @param value
     * @param key
     * @param other
     */
    formChange(value: { value: string, label: string }[], key: string, other: string) {
        try {
            const newValue = value.map((item) => (item.value));
            const newPrice = value.reduce((acc, cur) => {
                return acc += Number(cur.label.split(':')[1].split(getCurrencyName())[0])
            }, 0)
            this.onChange(newValue.toString(), key, {
                key: other,
                value: newPrice.toFixed(2)
            })
        }
        catch (e) {
            console.log(e)
        }
    }

    /**
     * 批量更改一级级菜单下所有菜品轮次限制
     */
    public async onChangeSwitch() {
        const { isJoiningGlobalLimit } = this.state
        this.setState({
            isJoiningGlobalLimit: !isJoiningGlobalLimit,
        }, async () => {
            const value = this.state.isJoiningGlobalLimit ? 1 : 0;
            const dishes: MenuDish[] = [];
            const menuItemSlu = this.props.detail.menu_item_slu || [];
            // 处理需要更改的字段
            menuItemSlu.forEach((item) => {
                (item?.menu_item || []).forEach((dish: MenuDish) => {
                    dishes.push({
                        item_id: dish.item_id,
                        not_joining_global_limit: value
                    })
                })
            })
            this.props.onChangeDishesTurnRule(dishes)
        })
    }

    // $ 新菜单价格
    /**
     * 处理新菜单价格方案
     */
    public handleNewMenuPrice = () => {
        const { curSelectWeek } = this.state
        const { extraMenuData } = this.props
        const curDetail = _.cloneDeep(this.state.detail);
        let curPricesForm = _.cloneDeep(this.state.curPricesForm);
        // $ 组合新菜单价格
        // 新菜单价格表单数组
        const curMenuPriceForm = [] as any;
        // 当前选中的菜单价格
        let curSelectMenuPriceForm = [] as any;
        if (curDetail?.set_item_main === '1') {
            // 额外费用菜单列表
            const extraMenuDataOptions = extraMenuData.map((item) => ({
                label: `${item.item_id}. ${item.item_name1}: ${item.price_1} ${getCurrencyName()}`,
                value: `${item.item_id}`
            }))
            // 新价格方案数组
            let newPriceArr: NewMenuPrice[] = []
            if (curDetail?.value && curDetail?.value.length > 0) {
                newPriceArr = curDetail.value
                curPricesForm = this.handlePriceFormByWeek(curPricesForm);
            } else {
                newPriceArr = setEmptyNewPriceValue();
                curDetail.value = setEmptyNewPriceValue();
            }
            newPriceArr.forEach((item) => {
                const formParams = [{
                    key: 'extra_normal',
                    label: 'menu_and_dishes_page_adult_price',
                    options: extraMenuDataOptions,
                    inputType: 'SELECT_MUL',
                    value: _.get(item, 'extra_normal') ? _.get(item, 'extra_normal')?.split(',') : [],
                    other: 'normal_price',
                },
                {
                    key: 'extra_child',
                    label: 'menu_and_dishes_page_child_price',
                    options: extraMenuDataOptions,
                    inputType: 'SELECT_MUL',
                    value: _.get(item, 'extra_child') ? _.get(item, 'extra_child')?.split(',') : [],
                    other: 'child_price',
                },
                {
                    key: 'extra_other',
                    label: 'menu_and_dishes_page_other_price',
                    options: extraMenuDataOptions,
                    inputType: 'SELECT_MUL',
                    value: _.get(item, 'extra_other') ? _.get(item, 'extra_other')?.split(',') : [],
                    other: 'other_price',
                }]
                if (curSelectWeek === item?.week as number) {
                    curSelectMenuPriceForm = formParams
                }
                curMenuPriceForm.push({
                    week: item?.week as number,
                    formArr: formParams
                })
            })
        } else {
            // ?
            [1, 2, 3, 4, 5, 6, 0].forEach(item => {
                curMenuPriceForm.push({
                    week: item,
                    formArr: setEmptyNewPriceForm(this.props.extraMenuData),
                })
            })
        }
        this.setState({
            curMenuPriceForm,
            curSelectMenuPriceForm,
            detail: curDetail,
            curPricesForm,
        })
    }

    /**
     * 处理价格表单数据 - 根据当前选中week值
     * @param pricesForm
     */
    public handlePriceFormByWeek = (
        pricesForm: Array<{
            key: string,
            label: string,
            regularType?: string,
            disabled?: boolean,
            width: number,
            require?: boolean,
            value: string,
        }>
    ) => {
        const { curSelectWeek, detail } = this.state
        let curPricesForm = _.cloneDeep(pricesForm);
        if (detail.value) {
            // 当前week值对应价格方案
            const filterIndex = detail.value.findIndex(n => {
                return n.week === curSelectWeek
            })
            if (filterIndex > -1) {
                const curDetailValue = detail.value[filterIndex]
                curPricesForm = curPricesForm.map(item => {
                    const deValue = _.get(curDetailValue, item.key);
                    const param = {
                        ...item,
                        value: deValue,
                    }
                    return param
                })
            }
        }
        return curPricesForm;
    }

    /**
     * 选中星期切换价格
     * @param key
     * @returns
     */
    public onSelectWeek = (key: number) => {
        const { curMenuPriceForm, curPricesForm } = this.state
        this.setState({
            curSelectWeek: key,
        }, () => {
            // 选中的菜单价格
            let curSelectMenuPrice: any[] = [];
            const filterIndex = curMenuPriceForm?.findIndex(n => {
                return n.week === key
            })
            if (filterIndex > -1) {
                curSelectMenuPrice = curMenuPriceForm[filterIndex].formArr;
            }
            const newPricesForm = this.handlePriceFormByWeek(curPricesForm);
            this.setState({
                curSelectMenuPriceForm: curSelectMenuPrice,
                curPricesForm: newPricesForm,
            })
        })
    }

    /**
     * 保存操作
     */
    public onSaveAction = () => {
        const { detail, avatarFile } = this.state
        // 名字不能为空
        const regular = BASE_CHECK_TYPE['required']?.regular;
        if (_.trim(detail.main_group_name) && regular.test(detail.main_group_name || '')) {
            this.props.onChangeFirstMenu(detail, avatarFile, this.isDelete);
            this.setState({
                avatarFile: undefined
            })
        }
    }

    /**
     * 修改表单
     * @param value
     * @param key
     * @param other 用来同步更新其他数据
     */
    onChangeForNewPrice(value: string, key: string, other?: { key: string, value: string }) {
        // eslint-disable-next-line prefer-const
        let { detail, curSelectMenuPriceForm, curSelectWeek, curMenuPriceForm, curPricesForm } = this.state;
        const newCurSelectMenuPriceForm = _.cloneDeep(curSelectMenuPriceForm).map(n => {
            if (n?.key === key) {
                if (other) {
                    n.value = value.split(',') || [];
                }
            }
            return n
        })

        for (const i in curMenuPriceForm) {
            if (curMenuPriceForm[i]?.week === curSelectWeek) {
                curMenuPriceForm[i].formArr = newCurSelectMenuPriceForm
                break;
            } else {
                continue;
            }
        }
        if (detail?.value) {
            const detailPrices = _.cloneDeep(detail.value)
            for (const i in detailPrices) {
                if (detailPrices[i]?.week === curSelectWeek) {
                    _.set(detailPrices[i], key, value);
                    other && _.set(detailPrices[i], other.key, Number(other.value))
                    break;
                } else {
                    continue;
                }
            }
            detail.value = detailPrices
        } else {
            const detailPrices = setEmptyNewPriceValue();
            for (const i in detailPrices) {
                if (detailPrices[i]?.week === curSelectWeek) {
                    _.set(detailPrices[i], key, value);
                    other && _.set(detailPrices[i], other.key, Number(other.value));
                    break;
                } else {
                    continue;
                }
            }
            detail.value = detailPrices
        }
        curPricesForm = this.handlePriceFormByWeek(curPricesForm);
        this.setState({
            curSelectMenuPriceForm: newCurSelectMenuPriceForm,
            curMenuPriceForm,
            detail,
            curPricesForm
        })
    }

    /**
     * 表单回调
     * @param value
     * @param key
     * @param other
     */
    formChangeForNewPrice(value: { value: string, label: string }[], key: string, other: string) {
        try {
            const newValue = value.map((item) => (item.value));
            const newPrice = value.reduce((acc, cur) => {
                return acc += Number(cur.label.split(':')[1].split(getCurrencyName())[0])
            }, 0)
            this.onChangeForNewPrice(newValue.toString(), key, {
                key: other,
                value: newPrice.toFixed(2)
            })
        }
        catch (e) {
            console.log(e)
        }
    }

    // 清空其他菜品标识
    async clearOtherDetailInfo() {
        setLoading(true)
        const result = await apiManage_rbp.deleteOtherDetailInfo();
        if (_.get(result, 'error')) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
        else {
            await this.props.getMenuData()
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            setLoading(false)
        }
    }

    async handleExport(type: 'current' | 'all') {
        let detail = this.props.detail;
        let menuData = this.props.menuData;
        const sheetData: sheetDataType = [
            {
                data: [], sheetName: 'Menu_Item', colConfig: {
                    'Unit1': { hidden: true }, 'Price2': { hidden: true }, 'Unit2': { hidden: true },
                    'Price3': { hidden: true }, 'Unit3': { hidden: true }, 'Price4': { hidden: true },
                    'Unit4': { hidden: true }, 'Price5': { hidden: true }, 'Unit5': { hidden: true },
                    'VIP_Price1': { hidden: true }, 'VIP_Price2': { hidden: true }, 'VIP_Price3': { hidden: true },
                    'VIP_Price4': { hidden: true }, 'VIP_Price5': { hidden: true }, 'slu_priority': { hidden: true },
                    'commission_type': { hidden: true }, 'commission_value': { hidden: true }, 'class_id': { hidden: true },
                    'is_time_price': { hidden: true }, 'price_per_minute': { hidden: true }, 'takeout_price_2': { hidden: true },
                    'takeout_price_3': { hidden: true }, 'takeout_price_4': { hidden: true }, 'takeout_price_5': { hidden: true },
                    'ta_description': { hidden: true }, 'ta_enable_takeout': { hidden: true }, 'ta_enable_eatin': { hidden: true },
                    'ta_enable_sales': { hidden: true }, 'ta_box_fee': { hidden: true }, 'ta_takeout_index': { hidden: true },
                    'ta_img_url': { hidden: true }, 'ta_img_url2': { hidden: true }, 'ta_img_url3': { hidden: true },
                    'ta_img_url4': { hidden: true }
                }
            },
            { data: [], sheetName: 'Secondary_Menu' },
            { data: [], sheetName: 'Main_Menu' }
        ]
        // 一级菜单下的二级菜单所有菜品
        if (type === 'current') {
            setLoading(true);
            const res = await apiManage_rbp.get_menus_v3({
                with_dish: true,
                main_group_id: detail.main_group_id
            })
            if (!_.get(res, 'error') && res?.length > 0) {
                detail = res?.[0]
            }
            setLoading(false);
        } else {
            setLoading(true);
            const res = await apiManage_rbp.get_menus_v3({
                type: 0,
                with_dish: true,
                rbpSort: 1,
            })
            if (!_.get(res, 'error') && res?.length > 0) {
                menuData = res
            }
            setLoading(false);
        }
        const arr = type === 'current' ? [detail] : menuData
        arr.forEach(item => {
            sheetData[2].data.push({ 'ID': item.main_group_id, 'Name': item.main_group_name })
            for (const second of (item.menu_item_slu || [])) {
                sheetData[1].data.push({
                    'ID': second.dmi_slu_id,
                    'Name': second.dmi_slu_name,
                    'Main_Menu': item.main_group_name
                })
                for (const dish of (second.menu_item || [])) {
                    sheetData[0].data.push({
                        'ID': dish.item_id,
                        'Name': dish.item_name1,
                        'SecondaryMenu': second.dmi_slu_name,
                        'Price1': dish.price_1,
                        'Unit1': dish.unit_1,
                        'Price2': dish.price_2,
                        'Unit2': dish.unit_2,
                        'Price3': dish.price_3,
                        'Unit3': dish.unit_3,
                        'Price4': dish.price_4,
                        'Unit4': dish.unit_4,
                        'Price5': dish.price_5,
                        'Unit5': dish.unit_5,
                        'Name2': dish.item_name2,
                        'VIP_Price1': '',
                        'VIP_Price2': '',
                        'VIP_Price3': '',
                        'VIP_Price4': '',
                        'VIP_Price5': '',
                        'nlu': dish.nlu,
                        'slu_priority': '',
                        'commission_type': '',
                        'commission_value': '',
                        'class_id': '',
                        'is_time_price': '',
                        'price_per_minute': '',
                        'takeout_price_1': dish.takeout_price_1,
                        'takeout_price_2': dish.takeout_price_2,
                        'takeout_price_3': dish.takeout_price_3,
                        'takeout_price_4': dish.takeout_price_4,
                        'takeout_price_5': dish.takeout_price_5,
                        'ta_description': '',
                        'ta_enable_takeout': '',
                        'ta_enable_eatin': '',
                        'ta_enable_sales': '',
                        'ta_box_fee': '',
                        'ta_takeout_index': '',
                        'ta_img_url': '',
                        'ta_img_url2': '',
                        'ta_img_url3': '',
                        'ta_img_url4': '',
                        'Pre_Descrizioni': dish.ext_dish_info,
                        'Descrizioni': dish.item_description,
                        'Allergeni': Array.isArray(dish.allergen) ? dish.allergen.join('*') : '',
                        'Caratteristiche': Array.isArray(dish.other_detail_info) ? dish.other_detail_info.join('*') : '',
                        'Limite_Ordinazioni': dish.rule_lnr_max_num,
                        'Quantita\' dei piatti limitata per tavolo': dish.rule_table_max_num
                    })
                }
            }
        })
        export2Excel(sheetData, type === 'current' ? detail.main_group_name || 'Menu' : 'Menu')
    }

    /**
     * 一键复制
     */
    oneClickCopy = () => {
        const { curMenuPriceForm, detail, curSelectWeek } = _.cloneDeep(this.state)

        const curMenuPriceFormItemFormArr = curMenuPriceForm.find((item) => item.week === curSelectWeek)?.formArr;
        const newCurMenuPriceForm = curMenuPriceForm.map((item) => {
            return {
                week: item.week,
                formArr: curMenuPriceFormItemFormArr ?? item.formArr
            }
        })

        const curDetailValueItem = detail?.value?.find((item) => item.week === curSelectWeek);
        const newDetailValue = detail?.value?.map((item) => {
            return {
                ...curDetailValueItem,
                week: item.week
            }
        })
        this.setState({
            curMenuPriceForm: newCurMenuPriceForm,
            detail: { ...detail, value: newDetailValue },
            isShowConfirmDialog: false
        })
    }
    // *********************
    // View
    // *********************

    render() {
        const { detail, curSelectWeek, curSelectMenuPriceForm, curPricesForm, isShowConfirmDialog } = this.state;
        const { extraMenuData } = this.props;
        // 额外费用菜单列表
        const extraMenuDataOptions = extraMenuData.map((item) => ({
            label: `${item.item_id}. ${item.item_name1}: ${item.price_1} ${getCurrencyName()}`,
            value: `${item.item_id}`
        }))
        const isJoiningGlobalLimit = this.props.detail.menu_item_slu?.reduce((acc, cur) => {
            return !!(acc && ((cur.menu_item || []).length > 0 ? cur.not_joining_global_limit : true))
        }, true)
        // 一级菜单下没有菜品
        // const isNoDish = this.props.detail.menu_item_slu?.reduce((acc, cur) => {
        //     return !!(acc && ((cur.menu_item || []).length === 0))
        // }, true)
        // 表单1
        const formArr1 = [
            {
                key: 'main_group_name',
                label: 'menu_and_dishes_page_group_name',
                regularType: 'required',
                width: 12 as const,
                require: true,
            },
            {
                key: 'normal_price',
                label: 'menu_and_dishes_page_adult_price',
                disabled: true,
                width: 4 as const,
                value: detail.normal_price ? Number(detail.normal_price || 0)?.toFixed(2) : ''
            },
            {
                key: 'child_price',
                label: 'menu_and_dishes_page_child_price',
                disabled: true,
                width: 4 as const,
                value: detail.child_price ? Number(detail.child_price || 0)?.toFixed(2) : ''
            },
            {
                key: 'other_price',
                label: 'menu_and_dishes_page_other_price',
                disabled: true,
                width: 4 as const,
                value: detail.other_price ? Number(detail.other_price || 0)?.toFixed(2) : ''
            },
        ]
        // 表单2
        const formArr2 = [
            {
                key: 'extra_normal',
                label: 'menu_and_dishes_page_adult_price',
                options: extraMenuDataOptions,
                inputType: 'SELECT_MUL',
                value: _.get(detail, 'extra_normal') ? _.get(detail, 'extra_normal')?.split(',') : [],
                other: 'normal_price'
            },
            {
                key: 'extra_child',
                label: 'menu_and_dishes_page_child_price',
                options: extraMenuDataOptions,
                inputType: 'SELECT_MUL',
                value: _.get(detail, 'extra_child') ? _.get(detail, 'extra_child')?.split(',') : [],
                other: 'child_price'
            },
            {
                key: 'extra_other',
                label: 'menu_and_dishes_page_other_price',
                options: extraMenuDataOptions,
                inputType: 'SELECT_MUL',
                value: _.get(detail, 'extra_other') ? _.get(detail, 'extra_other')?.split(',') : [],
                other: 'other_price'
            },
        ]

        // 新价格方案按钮组
        const buttonGroup = [
            {
                value: i18n.t('business_hour_page_Monday'),
                key: 1,
            },
            {
                value: i18n.t('business_hour_page_Tuesday'),
                key: 2,
            },
            {
                value: i18n.t('business_hour_page_Wednesday'),
                key: 3,
            },
            {
                value: i18n.t('business_hour_page_Thursday'),
                key: 4,
            },
            {
                value: i18n.t('business_hour_page_Friday'),
                key: 5,
            },
            {
                value: i18n.t('business_hour_page_Saturday'),
                key: 6,
            },
            {
                value: i18n.t('business_hour_page_Sunday'),
                key: 0,
            },
        ]


        return (
            <Card
                className='first-menu-detail-page'
                title={i18n.t('menu_and_dishes_page_basic_info')}
                actionRender={(
                    <>
                        <ButtonComponent
                            action='SAVE'
                            handleClick={this.onSaveAction}
                        />
                    </>
                )}
                contentRender={(
                    <Grid container spacing={4}>
                        <Grid container item spacing={4}>
                            {/* <Grid item>
                                <AvatarCard
                                    avatarUrl={avatarUrl}
                                    onChangeAvatarUrl={(url, file) => {
                                        this.isDelete = false;
                                        this.setState({
                                            avatarUrl: url,
                                            avatarFile: file
                                        })
                                    }}
                                    onDelete={() => {
                                        this.isDelete = true;
                                        this.setState({
                                            avatarUrl: '',
                                        })
                                    }}
                                />
                            </Grid> */}
                            <Grid item container spacing={4}>
                                {
                                    detail.set_item_main === '1' ?
                                        curPricesForm.map((item) => (
                                            <Grid item md={item.width} key={item.key}>
                                                <CommonInput
                                                    required={item.require}
                                                    regularType={item.regularType}
                                                    variant={'outlined'}
                                                    disabled={item.disabled}
                                                    fullWidth
                                                    label={item.label}
                                                    value={item.value || _.get(detail, item.key, '') || ''}
                                                    onChange={(event: any) => {
                                                        this.onChange(event.target.value, 'main_group_name')
                                                    }}
                                                />
                                            </Grid>
                                        ))
                                        :
                                        formArr1.map((item) => (
                                            <Grid item md={item.width} key={item.key}>
                                                <CommonInput
                                                    required={item.require}
                                                    regularType={item.regularType}
                                                    variant={'outlined'}
                                                    disabled={item.disabled}
                                                    fullWidth
                                                    label={item.label}
                                                    value={item.value || _.get(detail, item.key, '') || ''}
                                                    onChange={(event: any) => {
                                                        this.onChange(event.target.value, 'main_group_name')
                                                    }}
                                                />
                                            </Grid>
                                        ))
                                }
                            </Grid>
                        </Grid>
                        {/* 兼容新旧菜单价格方案 */}
                        {
                            // 新菜单价格
                            detail?.set_item_main === '1' ?
                                <>
                                    <Grid container item spacing={4} >
                                        <Grid    >
                                            <IconButton
                                                className='ml16'
                                                color='primary'
                                                onClick={() => {
                                                    this.setState({
                                                        isShowConfirmDialog: true
                                                    })
                                                }}>
                                                <FilterNone />
                                            </IconButton>
                                            <AlertDialog
                                                open={isShowConfirmDialog}
                                                size='xs'
                                                title={i18n.t('business_hour_page_click_copy')}
                                                desc={i18n.t('business_hour_page_this_operate_will_cover_others_if_continue')}
                                                onCancel={() => {
                                                    this.setState({ isShowConfirmDialog: false });
                                                }}
                                                onConfirm={this.oneClickCopy}
                                            />
                                            <ButtonGroup className='week-button-group' variant='outlined' aria-label='outlined button group'>
                                                {
                                                    buttonGroup.map((item) => (
                                                        <Button
                                                            key={item.key}
                                                            className={item.key === curSelectWeek ? 'btn-selected' : ''}
                                                            onClick={() => { this.onSelectWeek(item.key) }}>
                                                            {item.value}
                                                        </Button>
                                                    ))
                                                }
                                            </ButtonGroup>
                                        </Grid>
                                        {
                                            curSelectMenuPriceForm.map((formItem, index) => {
                                                const value: any[] = [];
                                                formItem?.options?.forEach(iitem => {
                                                    if (formItem.value.includes(iitem.value)) {
                                                        value.push(iitem)
                                                    }
                                                });
                                                return (
                                                    <Grid item xs={12} md={12} key={`new-price-${index}`}>
                                                        <CommonInput
                                                            color='secondary'
                                                            inputType={formItem.inputType as CommonInputType}
                                                            variant={'outlined'}
                                                            fullWidth
                                                            multipleProps={{
                                                                options: formItem.options,
                                                                label: i18n.t(formItem.label),
                                                                onChange: (value) => {
                                                                    if (value) {
                                                                        this.formChangeForNewPrice(value, formItem.key, formItem.other)
                                                                    }
                                                                },
                                                                value
                                                            }}
                                                        />
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid >
                                </>
                                :
                                // 旧菜单价格
                                <Grid container item spacing={4}>
                                    {
                                        formArr2.map((formItem) => {
                                            const value: any[] = [];
                                            formItem?.options?.forEach(iitem => {
                                                if (formItem.value?.includes(iitem.value)) {
                                                    value.push(iitem)
                                                }
                                            });
                                            return (
                                                <Grid item xs={12} md={12} key={formItem.key}>
                                                    <CommonInput
                                                        color='secondary'
                                                        inputType={formItem.inputType as CommonInputType}
                                                        variant={'outlined'}
                                                        fullWidth
                                                        multipleProps={{
                                                            options: formItem.options,
                                                            label: i18n.t(formItem.label),
                                                            onChange: (value) => {
                                                                if (value) {
                                                                    this.formChange(value, formItem.key, formItem.other)
                                                                }
                                                            },
                                                            value
                                                        }}
                                                    />
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid >
                        }
                        {

                            <Grid item xs={12}>
                                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <SwitchComponent
                                        value={isJoiningGlobalLimit}
                                        label={i18n.t('menu_and_dishes_page_batch_setup_dishes_away_round_limit')}
                                        onChange={() => {
                                            this.onChangeSwitch()
                                        }}
                                    />
                                    <div>
                                        <ButtonComponent titleText={i18n.t('menu_and_dishes_page_export_this_page_dishes')} handleClick={() => { this.handleExport('current') }} >{i18n.t('menu_and_dishes_page_export_this_page_dishes')}</ButtonComponent>
                                        <ButtonComponent titleText={i18n.t('menu_and_dishes_page_export_all_dishes')} handleClick={() => { this.handleExport('all') }} >{i18n.t('menu_and_dishes_page_export_all_dishes')}</ButtonComponent>
                                    </div>
                                </Box>
                            </Grid>
                        }
                    </Grid>
                )}
            />

        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 详情
    detail: FirstMenu;
    // 额外费用菜单 菜品形式
    extraMenuData: MenuDish[];
    // 额外费用菜单 菜单形式
    extraResult: FirstMenu[];
    // 更新一级菜单
    onChangeFirstMenu: (detail: FirstMenu, file?: File, deldeImg?: boolean) => void;
    // 批量更改二级菜单下所有菜品轮次限制
    onChangeDishesTurnRule: (dishes: MenuDish[]) => void;
    // 更新一级菜单数据
    getMenuData: () => Promise<void>;
    // 菜单
    menuData: FirstMenu[];
}
type State = {
    // 详情
    detail: FirstMenu;
    // 一级菜单图片
    avatarUrl: string;
    // 一级菜单图片文件
    avatarFile?: File;
    // 菜品不受轮次限制
    isJoiningGlobalLimit: boolean;
    // 当前选中的星期数 - 新菜单价格方案 (周日-周六 0 -6)
    curSelectWeek: number,
    // 当前菜单价格
    curMenuPriceForm: Array<{
        week: number,
        formArr: any[],
    }>,
    // 当前选中的菜单价格
    curSelectMenuPriceForm: any[],
    // 当前菜单价格表单
    curPricesForm: any[],
    // 二次确认 - 一键复制
    isShowConfirmDialog: boolean
}
